import {
  visitRecord,
  egressVisitLabel,
  addVisitRecord,
  getUserList,
  distributeVisit,
  getStaffList,
  handOver
} from '@/api/visit-record'

const state = {
}

const mutations = {
}

const actions = {
  // V-02-外访跟进记录
  visitRecord({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      visitRecord(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // V-06-外访标签
  egressVisitLabel({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      egressVisitLabel(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // V-03-添加外访跟进记录
  addVisitRecord({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      addVisitRecord(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // V-05-去访用户列表
  getUserList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getUserList(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  distributeVisit({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      distributeVisit(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getStaffList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getStaffList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  handOver({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      handOver(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  }

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
